// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {CSSProperties, Fragment, useCallback, useContext, useEffect,
    useMemo, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {toolip_img_url} from '../../../../../hola/pub/ui/toolip_img_url';
import etask from 'zetask';
import storage from '/util/storage.js';
import Icon_plans from '../../../img/icons/proxies.svg';
import Icon_buy from '../../../img/icons/16/buy.svg';
import Icon_account from '../../../img/icons/user.svg';
import Icon_chevron_left_duo from '../../../img/icons/chevron_left_duo.svg';
import Icon_chevron_right_duo from '../../../img/icons/chevron_right_duo.svg';
import Icon_chevron_down from '../../../../../hola/pub/img/hola2023/icons/16/chevron_down.svg';
import Icon_bell from '../../../../../hola/pub/img/hola2023/icons/16/bell.svg';
import Icon_book from '../../../img/icons/book.svg';
import Icon_link from '../../../img/icons/16/link2.svg';
import Icon_thank_you from '../../../img/dashboard/thank_you.svg';
import Icon_support from '../../../img/icons/16/support.svg';
import {use_pathname} from '../../../../../hola/pub/lib/use_pathname';
import {Settings_context} from '../../../../../hola/pub/settings_ctx';
import {use_app_context} from '../../../lib/app_context';
import {Button} from '../../../../../hola/pub/lib/button';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_screen} from '../../../../../hola/pub/lib/screen_util';
import {Modal} from '../../../../../hola/pub/lib/modal';
import {use_debug_ui} from '../../../../../hola/pub/lib/debug';
import {www_hola} from 'hola_opt';
import {Proxy_type} from '../../../../../hola/pub/ui/pro/cp/orders';
import {product_names} from '../../products/products';
import {use_translation_v} from '../../../../../hola/pub/lib/trans_v';
import styles from './main_menu.module.less';
import {Popup} from '../../popup/popup';
import {use_qs_with_set} from '../../../../../hola/pub/lib/use_qs';
import Logo_icon from '../../../img/toolip/logo_icon.svg';
import Logo_letters from '../../../img/toolip/logo_letters.svg';

const {SDC, DDC, RES, ISP, ISPPREM} = Proxy_type;

type t_logo_container_props = {
    collapsed: boolean
    toggle_collapsed: (e: React.MouseEvent<HTMLButtonElement>)=>void
};

const Logo_container = ({
  collapsed, toggle_collapsed}: t_logo_container_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.logo_container}>
      <Link to="/" className={styles.logo}>
        <div className={cn(styles.logo_wrapper, styles.full)}>
          <Logo_icon className={styles.full_icon}/>
          <Logo_letters className={styles.letters}/>
        </div>
        <img src={toolip_img_url('toolip/logo_icon.svg')}
          className={styles.icon}/>
      </Link>
      <Popup position='right' show_on_hover
        popup_cls={styles.item_text_popup}
        button={<Button on_click={toggle_collapsed}
          cls={styles.btn_toggle_new}
          size={'sm'} color={'transparent_grey'} no_padding
          caption={collapsed ? <Icon_chevron_right_duo /> :
            <Icon_chevron_left_duo/>}/>}>
        <div className={styles.item_text}>
          <p className={cn(theme.p12, theme.med, theme.color_n700)}>
            {collapsed ? 'Expand window' : 'Minimize window'}
          </p>
        </div>
      </Popup>
    </div>;
};

type t_main_menu_item = {
  id: string;
  text?: string;
  icon?: React.ReactNode;
  link?: string;
  param?: string;
  items?: t_main_menu_item[];
};

type t_main_menu_group = {
  id: string;
  text: string;
  items: t_main_menu_item[];
};

const Logout_confirmation = ({set_is_logout_open})=>{
  const {theme} = useContext(Settings_context);
  const {T, t} = use_translation_v({no_defaults: true});
  const logout = ()=>etask(function*(){
    yield fetch('/users/logout/inline', {method: 'POST',
      xhrFields: {withCredentials: true}});
    storage.clr_all();
    location.href = '/';
  });
  return <div className={styles.logout_confirmation}>
    <p className={cn(theme.p16, theme.med, theme.color_n700, styles.heading)}>
      <T>Ready to Head Out?</T>
    </p>
    <p className={cn(theme.p14, theme.med, theme.color_n400)}>
      <T>Are you sure you want to log out? Hit "Log Out" to go, or "Stay Here"
      if you're not quite done.</T>
    </p>
    <div className={styles.btn_container}>
      <Button caption={t('Log out')} round={false} color='transparent'
      on_click={logout}/>
      <Button caption={t('Stay Here')} round={false} cls={styles.stay_here_btn}
      on_click={()=>set_is_logout_open(false)}/>
    </div>
  </div>;
};

export const Sidebar = (props: {hide_items: Set<string>,
    unread_count: number})=>{
    const {hide_items} = props;
    const {T, t} = use_translation_v({no_defaults: true});
    const {theme} = useContext(Settings_context);
    const {user} = use_app_context();
    const {width} = use_screen();
    const [collapsed, set_collapsed] = useState(false);
    const [is_logout_open, set_is_logout_open] = useState(false);
    const [item_expanded, set_item_expanded] = useState(false);
    const toggle_collapsed = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>)=>{
            (e.target as HTMLElement).closest('button').blur();
            set_collapsed(v=>!v);
    }, []);
    const pricing_plans_debug = use_debug_ui('pricing_plans');
    const show_pricing_plans = pricing_plans_debug
        || www_hola.dashboard_pricing_plans;
    const menu_groups = useMemo(()=>{
        const groups: t_main_menu_group[] = [{
            id: 'general',
            text: 'General',
            items: [{
                id: 'plans',
                text: 'My proxies',
                icon: <Icon_plans />,
            }, show_pricing_plans && {
                id: 'pricing',
                text: 'Pricing plans',
                icon: <Icon_buy />,
                items: [{
                    id: SDC,
                    text: product_names[SDC],
                    param: 'type',
                }, {
                    id: DDC,
                    text: product_names[DDC],
                    param: 'type',
                }, {
                    id: RES,
                    text: product_names[RES],
                    param: 'type',
                }, {
                    id: ISP,
                    text: product_names[ISP],
                    param: 'type',
                }, {
                    id: ISPPREM,
                    text: product_names[ISPPREM],
                    param: 'type',
                }],
            }],
        }, {
            id: 'account',
            text: 'Account',
            items: [{
                id: 'account',
                text: 'My account',
                icon: <Icon_account />,
            },
            {
                id: 'notifications',
                text: `Notifications ${props.unread_count > 0 ?
                  ` (${props.unread_count})` : ''}`,
                icon: <Icon_bell />,
            }]
        }, {
            id: 'support',
            text: 'Support',
            items: [{
                id: 'help',
                text: 'Documentation',
                icon: <Icon_book />,
                link: 'https://docs.toolip.io/',
            },
            user ? {
              id: 'support_req',
              text: 'Support request',
              icon: <Icon_support />,
            }: null],
        }];
        return groups.map(g=>({...g, items: g.items.filter(v=>!!v)}));
    }, [show_pricing_plans]);
    useEffect(()=>{ set_collapsed(width < 1320); }, [width]);
    const sidebar_cls = cn(styles.sidebar, collapsed && styles.collapsed);
    return <div className={sidebar_cls}>
      <Modal lighter_close_btn={true}
        is_open={is_logout_open} width={403} paddingless={true}
        on_close={()=>set_is_logout_open(false)}
        on_overlay_click={()=>set_is_logout_open(false)}>
        <Logout_confirmation set_is_logout_open={set_is_logout_open}/>
      </Modal>
      <div className={styles.menu_container}>
        <Logo_container collapsed={collapsed}
          toggle_collapsed={toggle_collapsed} />
        <div className={styles.menu}>
          {menu_groups.map(group=>{
            return <div key={group.id} className={styles.menu_group}>
              <p className={cn(styles.menu_group_text, theme.p12, theme.med,
                theme.color_n300)}>
                <T>{group.text}</T></p>
              {group.items.filter(item=>!hide_items.has(item.id)).map(item=>{
                const target = group.id == 'support' ? '_blank' : undefined;
                const rel = group.id == 'support' ? 'noopener noreferrer'
                  : undefined;
                const subitems_count = collapsed ? 0 :
                  item.items?.length || 0;
                return <div key={item.id} style={{
                  '--subitems_count': subitems_count} as CSSProperties}
                  className={styles.menu_group_items}>
                  <Main_menu_link item={item}
                    target={target} rel={rel} collapsed={collapsed}
                    expanded={item_expanded}
                    set_expanded={set_item_expanded}
                    unread_count={props.unread_count}/>
                  <div className={styles.menu_item_tooltip}>
                    <p className={cn(theme.p12, theme.med,
                      theme.color_n700)}>
                      {item.text}
                    </p>
                  </div>
                </div>;
              })}
            </div>;
          })}
        </div>
      </div>
      <div className={styles.add_more_container}>
        {(collapsed || !item_expanded) &&
          <div className={styles.add_more_svg_wrapper}>
            <Icon_thank_you/>
          </div>}
        <p className={cn(collapsed && theme.p14, theme.med,
          theme.color_n700)}>{
          collapsed ? <T>Need more Proxies?</T> :
            <T>Need more Proxies?<br/>We've got you covered!</T>}</p>
        <Button caption={collapsed ? '+'+t('Add') : t('Add more proxies')}
          color={'black'} round={false} fit={collapsed}
          size={collapsed ? 'xs' : 'sm'} to={'/pricing'}
          as_external target="_blank"/>
      </div>
      {/* {!collapsed &&
        <Lang_picker direction='right' collapsed={collapsed}
          show_on_hover={false}/>} */}
      <div className={styles.overlay}/>
    </div>;
};

interface i_main_menu_link_props {
    unread_count?: number;
    item: t_main_menu_item;
    target?: string;
    rel?: string;
    collapsed?: boolean;
    parent?: t_main_menu_item;
    expanded?: boolean;
    set_expanded?:
        React.Dispatch<React.SetStateAction<boolean|(()=>void)>>;
}
const Main_menu_link = (props: i_main_menu_link_props)=>{
    const {item, target, rel, collapsed = false, parent,
        expanded, set_expanded} = props;
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const param = item.param || 'page';
    const {params, get_url} = use_pathname();
    const {qs, set_qs} = use_qs_with_set();
    const has_subitems = item.items?.length > 0;
    const sub_param = item.items?.[0]?.param;
    const is_active = params[param]==item.id && !params[sub_param];
    const item_cls = cn(styles.menu_item, theme.u2,
        is_active && styles.active,
        expanded && styles.expanded);
    const text_cls = cn(styles.menu_item_text,
        is_active ? theme.med : theme.color_n600);
    useEffect(()=>{
        if (is_active && !collapsed && params[sub_param])
            set_expanded(true);
    }, [params[sub_param], collapsed]);
    const to = useMemo(()=>{
        if (item.id == 'support_req')
            return;
        if (item.link)
            return {pathname: item.link};
        const opt = {type: undefined, [param]: item.id};
        if (parent)
            opt[parent.param || 'page'] = parent.id;
        return get_url(opt);
    }, [item, parent, qs]);
    const Menu_item_container = ({children})=>{
      return !collapsed && has_subitems ?
        <div className={styles.menu_item_container}>{children}</div> :
        <Fragment>{children}</Fragment>;
    };
    return <Menu_item_container>
      {item.id == 'support_req' ?
        <div key={item.id} className={item_cls}
          onClick={()=>set_qs({support_form: '1'})}>
          {item.icon}
          {!collapsed && <Fragment>
            <span className={cn(theme.P, theme.p14, text_cls)}>
              <T>{item.text}</T></span>
          </Fragment>}
        </div> :
        <Link key={item.id}
          onClick={()=>{
            if (collapsed || item.id != 'pricing')
              return;
            if (!is_active)
              return void set_expanded(true);
            if (!params[sub_param])
              set_expanded(v=>!v);
          }}
          to={to} className={item_cls}
          target={item.id != 'support_req' && target}
          rel={item.id != 'support_req' && rel}>
            {item.id === 'notifications' && props.unread_count > 0 ?
              <div className={styles.icon_badge}>
                {item.icon}
              </div> : item.icon
            }
          {!collapsed && <Fragment>
            <span className={cn(theme.P, theme.p14, text_cls)}>
              <T>{item.text}</T></span>
              {item.id === 'notifications' && props.unread_count > 0 &&
                <span className={cn(styles.unread_badge,
                  props.unread_count > 99 && styles.unread_badge_sm)}>
                  {props.unread_count > 99 ? '99+' : props.unread_count}
                </span>}
            {item.link && <Icon_link
              className={styles.arrow}/>}
            {has_subitems && !collapsed && <span className={styles.expander}
              onClick={ev=>{
                ev.preventDefault();
                ev.stopPropagation();
                set_expanded(v=>!v);
              }}
              ><Icon_chevron_down/></span>}
          </Fragment>}
        </Link>}
      {!collapsed && has_subitems && <div
        className={styles.subitems} style={{
          '--subitems_count': `${item.items.length}`
        } as CSSProperties}>
        {item.items.map(sub=><Main_menu_link key={sub.id} item={sub}
          parent={item} expanded={expanded}
          set_expanded={set_expanded}/>)}
      </div>}
    </Menu_item_container>;
};

interface i_topbar_menu_item extends t_main_menu_item {
  content?: JSX.Element;
}

export const Topbar = (props: {hide_items: Set<string>})=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const {params, get_url} = use_pathname();
    const w_ref = useRef<HTMLDivElement>();
    const pricing_plans_debug = use_debug_ui('pricing_plans');
    const show_pricing_plans = pricing_plans_debug
        || www_hola.dashboard_pricing_plans;
    const menu_items = useMemo(()=>{
        const items: i_topbar_menu_item[] = [{
        //     id: 'overview',
        //     text: 'Overview',
        //     icon: <img src={toolip_img_url('icons/dashboard.png')} width={16}/>,
        // }, {
            id: 'plans',
            text: 'Proxies',
            icon: <Icon_plans/>,
        }, show_pricing_plans && {
            id: 'pricing',
            text: 'Pricing',
            icon: <Icon_buy/>,
        }, {
            id: 'account',
            text: 'Account',
            icon: <Icon_account/>,
        }, {
            id: 'help',
            text: 'Documentation',
            icon: <Icon_book/>,
            link: 'https://docs.toolip.io/',
        }];
        return items.filter(v=>!!v);
    }, [show_pricing_plans]);
    return <div className={styles.topbar}>
      <div className={styles.wrapper} ref={w_ref}>
        {menu_items.filter(item=>!props.hide_items.has(item.id)).map(item=>{
          const item_cls = cn(styles.menu_item, theme.P, theme.p12,
            theme.med, params.page==item.id && styles.active);
          return <Link key={item.id} to={item.link ? {pathname: item.link}
            : get_url({page: item.id})} className={item_cls} data-id={item.id}
            target={item.link && '_blank'}>
            {item.icon} <T>{item.text}</T>
          </Link>;
        })}
      </div>
    </div>;
};
